<template>
  <div class="flex items-center mb-4">
      <span class="mr-3" v-if="feature.icon" v-html="feature.icon"></span>
      <p class="text-[14px]" v-if="feature.description" v-html="feature.description"></p>
  </div>
</template>

<script setup>

import { toRefs } from "vue";

const props = defineProps({
    feature: {
        type: Object,
        required: true
    }
})

const { feature } = toRefs(props);


</script>

<style>
</style>
